import { Pagination } from 'enums';

export const checkNumberElement = (skip: number, totalCount?: number) => {
  if (!totalCount) return 0;

  return skip + Pagination.TAKE > totalCount ? totalCount : skip + +Pagination.TAKE;
};
